import { ChainId } from '@padiswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x80bce63Fcdb2d2556A399c4DdA3C00A5FAF81B2D', // TODO
  [ChainId.TESTNET]: '0x80bce63Fcdb2d2556A399c4DdA3C00A5FAF81B2D'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
